export default __webpack_public_path__ + "static/media/iread8.af0e1307.jpeg";